import { useMutation } from '@apollo/client'
import {
   convertToErrorType,
   getAPIStatus
} from '@flowwai-frontend/bps-officer-web/common/data-access'
import { APIStatus } from '@flowwai-frontend/shared/api-common'

import {
   ClockOutMutation as Mutation,
   ClockOutMutationVariables as MutationVariables,
   ClockOutDocument as MutationDocument
} from './mutation.generatedTypes'
import useAPIResponseHandler from './responseHandler'

interface TriggerAPIArgs {
   onSuccess?: () => void
   onFailure?: () => void
}

interface ReturnType {
   triggerAPI: (args: TriggerAPIArgs) => void
   apiError: Error | null
   apiStatus: APIStatus
}

const useClockOut = (): ReturnType => {
   const { handleAPIResponse } = useAPIResponseHandler()

   const [clockOut, { loading, error }] = useMutation<
      Mutation,
      MutationVariables
   >(MutationDocument)

   const triggerAPI = (args: TriggerAPIArgs): void => {
      clockOut({
         onCompleted: (data: Mutation) => {
            handleAPIResponse(data, args.onSuccess)
         },
         onError: () => {
            if (args.onFailure) args.onFailure()
         }
      })
   }

   const apiStatus = getAPIStatus({
      isLoading: loading,
      isError: Boolean(error)
   })
   const apiError = convertToErrorType(error)

   return {
      triggerAPI,
      apiStatus,
      apiError
   }
}

export default useClockOut
